export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const getInitials = (name) => {
  if (!name) return "";
  const nameParts = name.split(" ");
  const initials = nameParts
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
  return initials;
};

export const InitialAvatar = ({ name }) => (
  <div
    style={{
      width: "30px",
      height: "30px",
      backgroundColor: "#007bff",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      fontSize: "14px",
      fontWeight: "bold",
    }}
  >
    {getInitials(name)}
  </div>
);

export const getImageUrl = (image) =>
  `${process.env.REACT_APP_API_BASE_URL}/uploads/${image}`;

export const getBadgeClass = (status) => {
  switch (status) {
    case "Early Arrival":
    case "Over Time":
    case "On Time":
      return "success";
    case "Late Comer":
    case "Early Exit":
      return "warning";
    case "Yes":
      return "success";
    case "No":
    case "Absent":
      return "danger";
    case "On Leave":
      return "secondary";
    case "Present":
      return "success";
    case "Checked In Only":
      return "primary";
    default:
      return "secondary";
  }
};

export const formatEmail = (email) => {
  if (!email) return "—";
  return email.length > 10 ? `${email.substring(0, 10)}...` : email;
};
